import { Button } from '@/shared/ui/Button';
import type { ReactNode } from 'react';
import React from 'react';
import { Typography } from '../Typography';
import Container from './Container';
import styles from './Container.module.scss';

interface CardProps {
	children?: ReactNode;
	disabled?: boolean;
	isFullHeight?: boolean;
	isGrid?: boolean;
	isLight?: boolean;
	onClick?: () => void;
	textButton?: string;
}

const Card = ({ isGrid, textButton, children, isLight, onClick, disabled, isFullHeight }: CardProps) => {
	return (
		<div className={styles.card} style={{ height: isFullHeight ? '100%' : '' }}>
			<Container isLight={isLight} isGrid={isGrid}>
				{children}
			</Container>
			{textButton ? (
				<div className={styles.buttonWrapper}>
					<Button disabled={disabled} onClick={onClick}>
						<Typography variant='title3' variantS='headline1'>
							{textButton}
						</Typography>
					</Button>
				</div>
			) : null}
		</div>
	);
};

export default Card;
